import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './ServiceCard.css';

const ServiceCard = ({ service }) => {
  const { i18n } = useTranslation();

  const getLocalizedField = (field) => {
    const langField = `${field}_${i18n.language}`;
    return service[langField] || service[`${field}_en`];
  };

  return (
    <Link to={`/services/${service.slug}`} className="service-card">
      <div className="service-card-image">
        {service.main_photo ? (
          <img src={service.main_photo} alt={getLocalizedField('title')} loading="lazy" />
        ) : (
          <div className="image-placeholder">No Image</div>
        )}
        
        {/* Overlay Content */}
        <div className="service-card-overlay">
          <div className="service-card-content">
            <div className="service-card-caption-wrapper">
              <h3>{getLocalizedField('title')}</h3>
            </div>
            <div className="service-card-short-desc-wrapper">
              <p className="service-card-short-desc">
                {getLocalizedField('short_description')}
              </p>
            </div>
          </div>
          
          {/* Popup Read More Button */}
          <div className="read-more-popup">
            <span className="read-more">
              {i18n.language === 'ka' ? 'დეტალურად' : 'Read more'}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ServiceCard;

